<template>
  <transition name='fade'>
    <div v-if='show' class='loader ct-flex-center'>
      <h2 v-for='(message, index) in messages' :key='index'>{{ message }}</h2>
      <div class='spinner'>
        <div class='bounce1'/>
        <div class='bounce2'/>
        <div class='bounce3'/>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TheLoading',

  computed: {
    show () {
      return this.$store.state.messagesLoading.length > 0
    },
    messages () {
      return this.$store.state.messagesLoading
    }
  }
}
</script>
